<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "EximCeisaSystemCode",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  